/**
 * Every string a fan reads on the invite sheet, in one place. American
 * English, no em dash, no en dash, no bare "code" (GLOSSARY-19). `plan.md`
 * `## 5.12` is the single source for these values. Do not reword them here.
 */

export const INVITE_SHEET_TITLE_PREFIX = "Invite to ";
export const INVITE_ENTRY_LABEL = "Invite to pool";

export const INVITE_CODE_FIELD_LABEL = "Invite code";
export const COPY_INVITE_CODE_LABEL = "Copy invite code";
export const INVITE_LINK_FIELD_LABEL = "Invite link";
export const COPY_INVITE_LINK_LABEL = "Copy link";
export const SHARE_LABEL = "Share";

export const INVITE_HEADER_LOADING_LABEL = "Loading your invite link";
export const INVITE_HEADER_FAILED_MESSAGE =
  "We couldn't load your invite link. Try again.";
export const INVITE_HEADER_RETRY_LABEL = "Try again";
export const INVITE_SHARING_OFF_MESSAGE =
  "Sharing is off in this pool right now. Ask a Commissioner to turn it back on.";

export const PEOPLE_TAB_LABEL = "People";
export const CHATS_TAB_LABEL = "Chats";
export const POOLS_TAB_LABEL = "Pools";

export const INVITE_SEARCH_LABEL = "Search by name or username";
export const PEOPLE_START_MESSAGE = "Type a name to find people to invite.";
export const PEOPLE_NO_RESULTS_MESSAGE =
  "Nobody matched that. Check the spelling and try again.";
export const PEOPLE_SEARCHING_LABEL = "Searching";

export const INVITE_ROW_ACTION_LABEL = "Invite to pool";
export const INVITE_ROW_INVITED_LABEL = "Invited";
export const INVITE_ROW_IN_POOL_LABEL = "In this pool";

export const INVITE_TAB_NOT_READY_NOTE =
  "Not ready yet. We're still building this. Check back soon.";

/**
 * The `Chats` tab, ISSUE-1097. A fan picks one of their chats and invites its
 * members, the same two steps as the `Pools` tab. A pool's own chat is left
 * out, and the note says so. Mobile carries the same strings in
 * `apps/mobile/src/pools/invite/inviteSourceCopy.ts` (ISSUE-197, 2026-10-19).
 */
export const CHATS_SOURCE_HEADING = "Invite from a chat";
export const CHATS_SOURCE_NOTE =
  "A pool's own chat is not listed here. To invite from a pool you run, use the Pools tab.";
export const CHATS_LOADING_LABEL = "Loading your chats";
export const CHATS_FAILED_MESSAGE =
  "We couldn't load your chats. Check your connection and try again.";
export const CHATS_EMPTY_TITLE = "No chats to invite from";
export const CHAT_PREVIEW_LOADING_LABEL = "Loading that chat's members";
export const CHAT_PREVIEW_FAILED_MESSAGE =
  "We couldn't load that chat's members. Check your connection and try again.";
export const CHAT_PREVIEW_EMPTY_BODY =
  "Everyone in that chat is already in this pool or already invited.";

/**
 * The `Pools` tab, ISSUE-197 R1, R3 and R4. The confirm headline and the sent
 * note are NOT here: they interpolate a live count, so they are derived by
 * `inviteConfirmHeadline()` and `inviteSentNote()` in `inviteBulkSelection.ts`
 * where a test can read them without rendering anything.
 */
export const POOLS_SOURCE_HEADING = "Invite from another pool";
export const POOLS_LOADING_LABEL = "Loading your pools";
export const POOLS_FAILED_MESSAGE =
  "We couldn't load your pools. Check your connection and try again.";
export const POOLS_EMPTY_TITLE = "No other pools to invite from";
export const POOLS_EMPTY_BODY =
  "You can bulk-invite from a pool where you are the Commissioner or an Admin.";

export const PREVIEW_LOADING_LABEL = "Loading that pool's members";
export const PREVIEW_FAILED_MESSAGE =
  "We couldn't load that pool's members. Check your connection and try again.";
export const PREVIEW_EMPTY_TITLE = "Everyone here is already in";
export const PREVIEW_EMPTY_BODY =
  "Every member of that pool is already in this one or already invited.";

export const INVITE_BULK_RETRY_LABEL = "Try again";
export const INVITE_BULK_CANCEL_LABEL = "Cancel";
export const INVITE_BULK_SEND_LABEL = "Send";
export const INVITE_BULK_DONE_LABEL = "Done";

export const SHARE_EMAIL_SUBJECT_PREFIX = "Join ";
export const SHARE_EMAIL_SUBJECT_SUFFIX = " on Sportsmet";
